import { Component, Input } from '@angular/core';
import { first } from 'rxjs/operators';

import { User } from '@app/_models';
import { UserService, AuthenticationService } from '@app/_services';
import { CourseService } from '@app/_services/course.service';
import { Router } from '@angular/router';
import { DashboardService } from '@app/_services/dashboard.service';

@Component({ selector: 'dashboard-header', templateUrl: 'dashboard-header.component.html' })
export class DashboardHeaderComponent {

    @Input() title: any;
    @Input() titleCssIcon: any;
    @Input() showStatus: boolean = false;
    @Input() showPendingTasks: boolean = false;

    userStatus = "";
    activitiesCount = 0;
    tasks: any[];
    pendingTask = false;
    completedTasksDismissed=false;

    constructor(private dashboardService: DashboardService) {}

    ngOnInit() {
        this.getJourneyTasks();
        this.getMyStatus();
        
        if(localStorage.getItem('completedTasksDismissed')) {
            this.completedTasksDismissed=true;
        }
    }

    getJourneyTasks() {
        this.dashboardService.getJourneyTasks().pipe(first()).subscribe(data => {
            this.tasks = data;

            this.pendingTask = this.tasks.filter(x => !x.completed).length > 0;
        });
    }

    getMyStatus() {
        this.dashboardService.getMyStatus().pipe(first()).subscribe(data => {
            this.userStatus =  data.status;
            this.activitiesCount = data.activitiesCount;
        });
    }

    onDismissTasks() {
        localStorage.setItem('completedTasksDismissed', 'true');
        this.completedTasksDismissed=true;
    }
}